<template>
  <dl class="layout mt-100">
    <template v-for="{ label, value, masked } in informations" :key="label">
      <dt class="caption-regular text-secondary-secondary">
        {{ label }}
      </dt>
      <dd class="paragraph-regular">
        <template v-if="masked">
          <LcMaskedValueDisplay v-if="masked">
            {{ value }}
          </LcMaskedValueDisplay>
        </template>
        <template v-else>
          {{ value }}
        </template>
      </dd>
    </template>
  </dl>
</template>

<script setup lang="ts">
import type { PayOutAccountBank } from '../../../../../core/api/shared/@types/generated/backend/graphql-schema-types'

type PayoutMethodDescriptedListBankProps = Pick<
  PayOutAccountBank,
  'accountNumber' | 'holderName' | 'routingNumber'
>

const { accountNumber, holderName, routingNumber } =
  defineProps<PayoutMethodDescriptedListBankProps>()

const { t } = useI18n()

const informations = computed(() => [
  { label: t('account.payout.accounts.accountholder'), value: holderName },
  {
    label: t('account.payout.accounts.routingnumber'),
    masked: true,
    value: routingNumber.replaceAll('*', ''),
  },
  {
    label: t('account.payout.accounts.accountnumber'),
    masked: true,
    value: accountNumber.replaceAll('*', ''),
  },
])
</script>

<style lang="scss" scoped>
.layout {
  display: grid;
  grid-template-columns: 6.188rem 1fr;
  gap: token('size/space/gap/050');
  align-items: center;
}
</style>
